import api from './api';

export const adminScannerService = {
    search: (query) => {
        return api.post('/admin/scanner/search', { query });
    },
    addStamp: (user_id) => {
        return api.post('/admin/scanner/stamp', { user_id });
    },
    redeem: (user_id) => {
        return api.post('/admin/scanner/redeem', { user_id });
    }
};
